import Card from 'components/Layout/Card'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { icons } from 'utils/constants'

const ProfileHeader = ({title}) => {
    const navigate = useNavigate()
    return (
        <Card>
            <div className="d-flex p-3 text-14-500" onClick={() => navigate(-1)}>
                <img
                    src={icons.leftArrow}
                    alt="back"
                    className="h-21 me-3 pointer"
                />
                {title}
            </div>
        </Card>
    )
}

export default ProfileHeader
